<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { Validator } from 'vee-validate';
  import { hiddenAreas } from '@/config';

  export default {
    data () {
      return {
        lastOperationTime: new Date().getTime(),
        currentTime: new Date().getTime(),
        tOut: 10 * 60 * 1000
      }
    },
    computed: {
      ...mapState(["USER","LANGUAGE","PAGEMAXINDEX"]),
    },
    beforeCreate() {
      if(this.$route.redirectedFrom && this.$route.redirectedFrom.indexOf('fromSpbo2')>0){
        let info = atob(this.$router.currentRoute.query.info)
        let obj = JSON.parse(info)
        this.$http.interceptors.request.use(function (conf) {
          conf.headers['spbo2_auth'] = obj.auth
          return conf
        });
        sessionStorage.user = JSON.stringify(obj.user)
        let area20 = obj.area20.filter((area)=>!hiddenAreas.includes(area));
        sessionStorage.area20 = JSON.stringify(area20)
        sessionStorage.profitshare_area = JSON.stringify(profitshare_area)
        let currentArea20 = {
          group: profitshare_area[0],
          value: area20[0]
        }
        sessionStorage.currentArea20 = JSON.stringify(currentArea20)
        sessionStorage.fromSpbo2 = true;
        window.addEventListener("message",(e)=>{
          if(['cn','en','hk'].indexOf(e.data)>=0){
            this.SAVELANGUAGE(e.data)
            localStorage.language = e.data
          }
        })
        this.$nextTick(()=>{
          this.SAVELANGUAGE(obj.lang)
          localStorage.language = obj.lang
        })
        return;
      }
    },
    mounted() {
      this.SAVELANGUAGE(localStorage.language || "cn")
      this.SAVEPAGEMAXINDEX(localStorage.pageMaxIndex || 0)
      this.SAVEUSER(sessionStorage.user)

      if (!this.USER) {
        // this.$router.push("/login")
        this.$router.push(this.$route.query.link ? '/login?link='+this.$route.query.link : '/login')
      }

      document.body.addEventListener("click", () => {
        this.lastOperationTime = new Date().getTime()
      })

      window.setInterval(this.tTime, 10000)
    },
    methods: {
      ...mapMutations([
        "SAVELANGUAGE",
        "SAVEUSER",
        "SAVEPAGEMAXINDEX"
      ]),
      tTime () {
        if(sessionStorage.fromSpbo2) return;
        this.currentTime = new Date().getTime()
        if(this.currentTime - this.lastOperationTime > this.tOut) {
          sessionStorage.clear()
          this.$router.push({path: '/'})
        }
      }
    }
  }
</script>

<style lang="scss" type="text/css">
  @import "common/sass/assets.css";
  @import "common/sass/index.SCSS";

  body{
    min-height: 90%;
    background-color: #FAFCFE;
  }
  .page-container{
    min-height: 901px;
  }
  .el-loading-spinner i{
    color: #3F51B5;
    font-size: 45px;
  }
  .change-el-input-group-style {
    .el-input-group>.el-input__inner {
        display: inline-block!important;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?612bcbae